// extracted by mini-css-extract-plugin
export default {"foldersName":"foldersName--f3524c25","selectedFileText":"selectedFileText--f8d1254a","errorMessage":"errorMessage--241fcc2f"};